module.exports = __webpack_public_path__ + "media/images/icon__burger-menu@2x-e935c03ea9965b23acba834e4c84f2cb.png";